<template>
  <div class="merchant-price-page">
    <basic-container>
      <!-- 标签页切换：防水 / 回填 -->
      <el-tabs v-model="activeTab" @tab-click="handleTabChange">
        <el-tab-pane label="商家防水价格" name="waterproof" />
        <el-tab-pane label="商家回填价格" name="backfill" />
      </el-tabs>

      <avue-crud
        ref="crud"
        :option="tableOption"
        :data="tableData"
        :page="page"
        :table-loading="tableLoading"
        @on-load="handleList"
        @search-change="handleSearch"
        @search-reset="handleReset"
        @row-save="handleRowSave"
        @row-update="handleRowUpdate"
        @selection-change="handleSelectionChange"
        @refresh-change="handleRefreshChange"
      >
        <template slot="menuLeft">
          <el-button type="primary" icon="el-icon-plus" size="small" @click="handleAdd">
            新增{{ currentTabLabel }}
          </el-button>
          <el-button
            type="danger"
            icon="el-icon-delete"
            size="small"
            plain
            :disabled="!selectedIds.length"
            @click="handleBatchDelete"
          >
            批量删除
          </el-button>
        </template>
        <template slot="unitPrice" slot-scope="scope">
          <span style="color:#e6a23c;font-weight:600">{{ scope.row.unitPrice }}</span>
          <span style="color:#909399;font-size:12px"> 元/㎡</span>
        </template>
        <template slot="thresholdSqm" slot-scope="scope">
          <span v-if="scope.row.thresholdSqm != null">{{ scope.row.thresholdSqm }}</span>
          <span v-else style="color:#c0c4cc">-</span>
        </template>
        <template slot="enabled" slot-scope="scope">
          <el-switch
            :value="scope.row.enabled === 1"
            @change="handleToggleEnabled(scope.row, $event)"
          />
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button type="text" icon="el-icon-edit" size="small" @click="handleEdit(scope.row)">
            编辑
          </el-button>
          <el-button
            type="text"
            icon="el-icon-delete"
            size="small"
            style="color:#f56c6c"
            @click="handleDelete(scope.row)"
          >
            删除
          </el-button>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
import { merchantTableOption, merchantFormOption } from "@/const/work/waterProof/merchantPriceOption";
import {
  findWaterproofMerchantPrice,
  addWaterproofMerchantPrice,
  updateWaterproofMerchantPrice,
  deleteWaterproofMerchantPrice,
  findBackfillMerchantPrice,
  addBackfillMerchantPrice,
  updateBackfillMerchantPrice,
  deleteBackfillMerchantPrice,
} from "@/api/work/waterProof/merchantPrice";

export default {
  name: "merchantPrice",
  data() {
    return {
      activeTab: "waterproof",
      tableOption: { ...merchantTableOption, formOption: { ...merchantFormOption } },
      tableData: [],
      tableLoading: false,
      selectedIds: [],
      page: { total: 0, currentPage: 1, pageSize: 10 },
      searchParams: {},
    };
  },
  computed: {
    currentTabLabel() {
      return this.activeTab === "waterproof" ? "商家防水价格" : "商家回填价格";
    },
  },
  methods: {
    // 获取当前标签的 API 函数映射
    getApi(type) {
      if (type === "backfill") {
        return {
          list: findBackfillMerchantPrice,
          add: addBackfillMerchantPrice,
          update: updateBackfillMerchantPrice,
          del: deleteBackfillMerchantPrice,
        };
      }
      return {
        list: findWaterproofMerchantPrice,
        add: addWaterproofMerchantPrice,
        update: updateWaterproofMerchantPrice,
        del: deleteWaterproofMerchantPrice,
      };
    },
    // 组装查询参数
    buildParams() {
      const params = {
        page: this.page.currentPage,
        size: this.page.pageSize,
      };
      Object.keys(this.searchParams).forEach((k) => {
        if (this.searchParams[k] !== "" && this.searchParams[k] !== null) {
          params[k] = this.searchParams[k];
        }
      });
      return params;
    },
    // 列表加载
    handleList() {
      this.tableLoading = true;
      const api = this.getApi(this.activeTab);
      api
        .list(this.buildParams())
        .then((res) => {
          if (res.code === "200") {
            const data = typeof res.data === "string" ? JSON.parse(res.data) : res.data || {};
            const rows = data.rows || [];
            // 响应式处理 enable 字段
            rows.forEach((r) => {
              if (r.enabled == null) this.$set(r, "enabled", 1);
            });
            this.tableData = rows;
            this.page.total = data.total || 0;
          } else {
            this.$message.error(res.message || "加载失败");
          }
        })
        .catch((err) => {
          console.log("handleList error:", err);
          this.$message.error("加载异常");
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    handleSearch(params) {
      this.searchParams = params || {};
      this.page.currentPage = 1;
      this.handleList();
    },
    handleReset() {
      this.searchParams = {};
      this.page.currentPage = 1;
      this.handleList();
    },
    handleTabChange() {
      this.searchParams = {};
      this.selectedIds = [];
      this.page.currentPage = 1;
      this.handleList();
    },
    // 新增
    handleAdd() {
      this.$refs.crud.rowAdd();
    },
    // 编辑
    handleEdit(row) {
      this.$refs.crud.rowEdit(row);
    },
    // 新增保存
    handleRowSave(row, done) {
      const api = this.getApi(this.activeTab);
      api
        .add(row)
        .then((res) => {
          if (res.code === "200") {
            this.$message.success("新增成功");
            done();
            this.handleList();
          } else {
            this.$message.error(res.message || "新增失败");
            done();
          }
        })
        .catch((err) => {
          console.log("handleRowSave error:", err);
          this.$message.error("新增异常");
          done();
        });
    },
    // 编辑保存
    handleRowUpdate(row, index, done) {
      const api = this.getApi(this.activeTab);
      api
        .update(row)
        .then((res) => {
          if (res.code === "200") {
            this.$message.success("编辑成功");
            done();
            this.handleList();
          } else {
            this.$message.error(res.message || "编辑失败");
            done();
          }
        })
        .catch((err) => {
          console.log("handleRowUpdate error:", err);
          this.$message.error("编辑异常");
          done();
        });
    },
    handleToggleEnabled(row, val) {
      const target = val ? 1 : 0;
      const api = this.getApi(this.activeTab);
      api
        .update({ ...row, enabled: target })
        .then((res) => {
          if (res.code === "200") {
            this.$set(row, "enabled", target);
            this.$message.success(target === 1 ? "已启用" : "已禁用");
          } else {
            this.$message.error(res.message || "状态切换失败");
          }
        })
        .catch((err) => {
          console.log("handleToggleEnabled error:", err);
          this.$message.error("状态切换异常");
        });
    },
    handleDelete(row) {
      this.$confirm(`确定删除「${row.merchantName || row.merchantPhone}」吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const api = this.getApi(this.activeTab);
          api
            .del(row.id)
            .then((res) => {
              if (res.code === "200") {
                this.$message.success("删除成功");
                this.handleList();
              } else {
                this.$message.error(res.message || "删除失败");
              }
            })
            .catch((err) => {
              console.log("handleDelete error:", err);
              this.$message.error("删除异常");
            });
        })
        .catch(() => {});
    },
    // 弹窗关闭/取消时刷新
    handleRefreshChange() {
      this.handleList();
    },
    handleSelectionChange(selection) {
      this.selectedIds = (selection || []).map((i) => i.id);
    },
    handleBatchDelete() {
      if (!this.selectedIds.length) {
        this.$message.warning("请先选择要删除的项");
        return;
      }
      this.$confirm(
        `确定删除选中的 ${this.selectedIds.length} 条记录吗？`,
        "提示",
        { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning" }
      )
        .then(() => {
          const api = this.getApi(this.activeTab);
          api
            .del(this.selectedIds.join(","))
            .then((res) => {
              if (res.code === "200") {
                this.$message.success("批量删除成功");
                this.selectedIds = [];
                this.handleList();
              } else {
                this.$message.error(res.message || "批量删除失败");
              }
            })
            .catch((err) => {
              console.log("handleBatchDelete error:", err);
              this.$message.error("批量删除异常");
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.merchant-price-page {
  ::v-deep .el-tabs__header {
    margin-bottom: 8px;
  }
}
</style>
